"use client";
import { jsx } from "react/jsx-runtime";
import { getLinkBehavior } from "../../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { dynamicImagePlacement } from "../util.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { useCheckScreen } from "../../../../hooks/useCheckScreen/index.js";
import { StaticTileBlock } from "./StaticTileBlock.js";
const ProgramTile = ({
  locale = "en-us",
  disableThirdPartyTracking,
  entryId,
  hasBottomStrip,
  programCardConfig,
  programCardLink,
  programCardTitle,
  roundedFirstTile,
  roundedLastTile,
  tile,
  tileCounter
}) => {
  const { isSmMobile, isMobile, isTablet } = useCheckScreen();
  const { tile_link } = tile;
  const programTileSize = dynamicImagePlacement(
    programCardConfig == null ? void 0 : programCardConfig.enable_dynamic_row_config,
    programCardConfig == null ? void 0 : programCardConfig.dynamic_row_config,
    programCardConfig == null ? void 0 : programCardConfig.image_type,
    isMobile,
    isTablet
  );
  const tileLink = (tile_link == null ? void 0 : tile_link.url) ? tile_link.url : programCardLink == null ? void 0 : programCardLink.url;
  const { target } = getLinkBehavior(
    tile_link == null ? void 0 : tile_link.external_site,
    tile_link == null ? void 0 : tile_link.same_tab_domain
  );
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        borderRadius: "10px",
        flexBasis: isSmMobile ? "100%" : `${programTileSize}%`,
        flexGrow: 1
      },
      children: tileLink ? /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            adItem: {
              isExternal: (tile_link == null ? void 0 : tile_link.external_site) || (programCardLink == null ? void 0 : programCardLink.external_site) || false,
              title: (tile_link == null ? void 0 : tile_link.title) || "",
              url: tileLink || ""
            },
            title: programCardTitle
          },
          children: /* @__PURE__ */ jsx(
            Link,
            {
              dataPrivate: disableThirdPartyTracking,
              href: tileLink,
              underline: "none",
              uniqueId: `programcardtile_${entryId}_${tileCounter}`,
              target,
              children: /* @__PURE__ */ jsx(
                StaticTileBlock,
                {
                  locale,
                  entryId,
                  hasBottomStrip,
                  programCardConfig,
                  roundedFirstTile,
                  roundedLastTile,
                  tile,
                  tileCounter
                }
              )
            }
          )
        }
      ) : /* @__PURE__ */ jsx(
        StaticTileBlock,
        {
          locale,
          entryId,
          hasBottomStrip,
          programCardConfig,
          roundedFirstTile,
          roundedLastTile,
          tile,
          tileCounter
        }
      )
    }
  );
};
export {
  ProgramTile
};
